<template>
    <playback-controls 
      id="oct-slice-contorls"
      :index="index" 
      :count="count" 
      :isPlaying="isPlaying"
      :playRate="playRate"
      @previous="$emit('previous')"
      @next="$emit('next')"
      @play="$emit('play')"
      @pause="$emit('pause')"
      @setPlayRate="$emit('setPlayRate', $event)" />
</template>

<script>
import playbackControls from "../controls/PlaybackControls";
export default {
  name: "octSliceControls",
  components: { playbackControls },
  props: {
    index: Number, count: Number, playRate: String, isPlaying: Boolean
  }
};
</script>
<style lang="scss" scoped>
  .oct-comparison-view{
    #oct-slice-contorls{
     margin-right: 17%;
    }
  }
</style>